// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { CustomEvent } from '../../CustomEvents';
import { WatchlistManager } from './WatchlistManager';
import { WatchlistSheetItem } from './WatchlistSheetItem';
import { WatchlistSheetsStorageManager } from './WatchlistSheetsStorageManager';
export class _WatchlistSheets {
    constructor() {
        this._items = [];
    }
    get items() {
        return this._items;
    }
    set items(_items) {
        this._items = _items;
        this.onSettingsChanged();
    }
    restore(newWLSheets) {
        for (const key in newWLSheets) {
            if (Object.prototype.hasOwnProperty.call(newWLSheets, key)) {
                this[key] = newWLSheets[key];
            }
        }
        this.onSettingsChanged();
    }
    getAllSymbolIds(items) {
        const symbolIds = [];
        items.forEach((item) => {
            symbolIds.push(...item.getSymbolIds());
        });
        return symbolIds;
    }
    static serialize(items) {
        const saveList = items.map((item) => ({
            name: item.name,
            itemsStr: item.getSymbolIds().join(';')
        }));
        return JSON.stringify(saveList);
    }
    static deserialize(json) {
        const wlSheets = new _WatchlistSheets();
        const sheets = JSON.parse(json);
        sheets.forEach((sheet) => {
            var _a, _b;
            if (sheet.name) {
                const symbolIds = (_b = (_a = sheet.itemsStr) === null || _a === void 0 ? void 0 : _a.split(';').filter((symbol) => symbol)) !== null && _b !== void 0 ? _b : [];
                wlSheets.items.push(new WatchlistSheetItem(sheet.name, new Set(symbolIds)));
            }
        });
        return wlSheets;
    }
    onSettingsChanged() {
        _WatchlistSheets.itemsChanged.Raise();
        WatchlistSheetsStorageManager.wasChanged();
        WatchlistManager.updateStorageItems();
    }
}
_WatchlistSheets.itemsChanged = new CustomEvent();
export const WatchlistSheets = new _WatchlistSheets();
